import { doRequestReturnStandard, doRequestSimple, doRequestWithResponse } from '.';
import { baseApiUrl, requestOptionsDelete, requestOptionsGet, requestOptionsPost, requestOptionsPut } from '../_constants/emparkConstants';

/* Buckets */
export async function getBuckets(contextId) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets`;

    return await doRequestWithResponse(apiUrl, requestOptionsGet());
    // return {
    //     data: [
    //         { id: '1', name: 'Bucket 1', bucketDefinitionId: '1', bucketDefinitionName: 'def 1', description: 'descrition 1', bucketType: 'FORCED_ROTATION' },
    //         { id: '3', name: 'Bucket 3', bucketDefinitionId: '1', bucketDefinitionName: 'def 3', description: 'descrition 3', bucketType: 'FORCED_ROTATION' },
    //         { id: '2', name: 'Bucket 2', bucketDefinitionId: '2', bucketDefinitionName: 'def 2', description: 'descrition 2', bucketType: 'FREE_PERIODS' },
    //         { id: '4', name: 'Bucket 4', bucketDefinitionId: '4', bucketDefinitionName: 'def 4', description: 'descrition 4', bucketType: 'FREE_PERIODS' },
    //     ]
    // }
}

export async function createBucket(contextId, bucket) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPost(), body: JSON.stringify(bucket) });
}

export async function updateBucket(contextId, bucket) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/${bucket.id}`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPut(), body: JSON.stringify(bucket) });
}

export async function deleteBucket(contextId, bucketId) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/${bucketId}`;

    return await doRequestSimple(apiUrl, requestOptionsDelete());
}

export async function createBucketPeriod(contextId, bucketId, bucketPeriod) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/${bucketId}/periods`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPost(), body: JSON.stringify(bucketPeriod) });
}

export async function updateBucketPeriod(contextId, bucketId, bucketPeriod) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/${bucketId}/periods/${bucketPeriod.id}`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPut(), body: JSON.stringify(bucketPeriod) });
}

export async function deleteBucketPeriod(contextId, bucketId, bucketPeriodId) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/${bucketId}/periods/${bucketPeriodId}`;

    return await doRequestSimple(apiUrl, requestOptionsDelete());
}

export async function updateBucketPeriodChild(contextId, bucketId, bucketPeriodId, childType, childIds) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/${bucketId}/periods/${bucketPeriodId}/children?childType=${childType}`;

    return await doRequestSimple(apiUrl, { ...requestOptionsPost(), body: JSON.stringify(childIds) });
}

/* Bucket definitions */
export async function getBucketDefinitions(contextId) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/definitions`;

    return await doRequestWithResponse(apiUrl, requestOptionsGet());
    // return {
    //     data: [
    //         {
    //             id: '1', name: 'Bucket def 1', bucketType: 'FORCED_ROTATION', bucketSchedules: [
    //                 {
    //                     id: '1', daysBitMask: '12345', bucketForcedRotationResets: [
    //                         { id: '1', resetType: 'FIXED', startHour: '09:00:00', maxDurationAfterReset: 'PT3H' },
    //                         { id: '2', resetType: 'SINGLE_SESSION_DYNAMIC', startHour: '12:00:00', maxParkingDuration: 'PT3H', bufferDuration: 'PT2H' }
    //                     ], bucketFreePeriodResets: []
    //                 },
    //                 {
    //                     id: '2', daysBitMask: '67', bucketForcedRotationResets: [
    //                         { id: '3', resetType: 'MULTIPLE_SESSION_DYNAMIC', startHour: '12:00:00', automaticResetAfterBufferDuration: true, maxParkingDuration: 'PT3H', bufferDuration: 'PT2H' }
    //                     ], bucketFreePeriodResets: []
    //                 }
    //             ]
    //         },
    //         {
    //             id: '2', name: 'Bucket def 2', bucketType: 'FORCED_ROTATION', bucketSchedules: [
    //                 { id: '3', daysBitMask: '123', bucketForcedRotationResets: [], bucketFreePeriodResets: [] },
    //                 { id: '4', daysBitMask: '6', bucketForcedRotationResets: [], bucketFreePeriodResets: [] }
    //             ]
    //         },
    //         {
    //             id: '3', name: 'Bucket def 3', bucketType: 'FREE_PERIODS', bucketSchedules: [
    //                 {
    //                     id: '5', daysBitMask: '123', bucketForcedRotationResets: [], bucketFreePeriodResets: [
    //                         { id: '4', startHour: '12:00:00', freePeriod: "PT1H", divisible: true },
    //                         { id: '5', startHour: '15:00:00', freePeriod: "PT2H", divisible: false }
    //                     ]
    //                 },
    //                 { id: '6', daysBitMask: '6', bucketForcedRotationResets: [], bucketFreePeriodResets: [] }
    //             ]
    //         },
    //         {
    //             id: '4', name: 'Bucket def 4', bucketType: 'FREE_PERIODS', bucketSchedules: [
    //                 { id: '7', daysBitMask: '123', bucketForcedRotationResets: [], bucketFreePeriodResets: [] },
    //                 { id: '8', daysBitMask: '6', bucketForcedRotationResets: [], bucketFreePeriodResets: [] }
    //             ]
    //         },
    //     ]
    // }
}

export async function createBucketDefinition(contextId, bucket) {
    console.log('createBucketDefinition', bucket);
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/definitions`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPost(), body: JSON.stringify(bucket) });
}

export async function updateBucketDefinition(contextId, bucketDefinition) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/definitions/${bucketDefinition.id}`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPut(), body: JSON.stringify(bucketDefinition) });
}

export async function deleteBucketDefinition(contextId, bucketDefinitionId) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/definitions/${bucketDefinitionId}`;

    return await doRequestSimple(apiUrl, requestOptionsDelete());
}

export async function createBucketSchedule(contextId, bucketDefinitionId, bucketSchedule) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/definitions/${bucketDefinitionId}/schedules`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPost(), body: JSON.stringify(bucketSchedule) });
}

export async function updateBucketSchedule(contextId, bucketDefinitionId, bucketSchedule) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/definitions/${bucketDefinitionId}/schedules/${bucketSchedule.id}`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPut(), body: JSON.stringify(bucketSchedule) });
}

export async function deleteBucketSchedule(contextId, bucketDefinitionId, bucketScheduleId) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/definitions/${bucketDefinitionId}/schedules/${bucketScheduleId}`;

    return await doRequestSimple(apiUrl, requestOptionsDelete());
}

export async function createBucketForcedRotationReset(contextId, bucketScheduleId, reset) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/schedules/${bucketScheduleId}/forced-rotation-resets`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPost(), body: JSON.stringify(reset) });
}

export async function updateBucketForcedRotationReset(contextId, bucketScheduleId, reset) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/schedules/${bucketScheduleId}/forced-rotation-resets/${reset.id}`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPut(), body: JSON.stringify(reset) });
}

export async function deleteBucketForcedRotationReset(contextId, bucketScheduleId, resetId) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/schedules/${bucketScheduleId}/forced-rotation-resets/${resetId}`;

    return await doRequestSimple(apiUrl, requestOptionsDelete());
}

export async function createBucketFreePeriodReset(contextId, bucketScheduleId, reset) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/schedules/${bucketScheduleId}/free-periods-resets`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPost(), body: JSON.stringify(reset) });
}

export async function updateBucketFreePeriodReset(contextId, bucketScheduleId, reset) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/schedules/${bucketScheduleId}/free-periods-resets/${reset.id}`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPut(), body: JSON.stringify(reset) });
}

export async function deleteBucketFreePeriodReset(contextId, bucketScheduleId, resetId) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/buckets/schedules/${bucketScheduleId}/free-periods-resets/${resetId}`;

    return await doRequestSimple(apiUrl, requestOptionsDelete());
}

export async function getPeriodBuckets(rateId, periodId) {
    const apiUrl = `${baseApiUrl}rates/${rateId}/periods/${periodId}/buckets`;

    return await doRequestWithResponse(apiUrl, requestOptionsGet());
}

export async function createPeriodBucket(rateId, periodId, periodBucket) {
    const apiUrl = `${baseApiUrl}rates/${rateId}/periods/${periodId}/buckets`;

    return await doRequestWithResponse(apiUrl, requestOptionsPost(), { body: JSON.stringify(periodBucket) });
}

export async function updatePeriodBucket(rateId, periodId, periodBucket) {
    const apiUrl = `${baseApiUrl}rates/${rateId}/periods/${periodId}/buckets/${periodBucket.id}`;

    return await doRequestWithResponse(apiUrl, requestOptionsPut(), { body: JSON.stringify(periodBucket) });
}

export async function deletePeriodBucket(rateId, periodId, periodBucketId) {
    const apiUrl = `${baseApiUrl}rates/${rateId}/periods/${periodId}/buckets/${periodBucketId}`;

    return await doRequestWithResponse(apiUrl, requestOptionsDelete());
}